import React from 'react';
import { API_BASE, toUrl } from '../lib/config';

const Dashboard: React.FC = () => {
  

  const [stats, setStats] = React.useState({
    applicationsNew: null as number | null,
    media: null as number | null,
    doctors: null as number | null,
  });
  const [loading, setLoading] = React.useState(false);

  const safeFetchJson = async (url: string) => {
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error('bad');
      return await res.json();
    } catch {
      return null;
    }
  };

  const refresh = React.useCallback(async () => {
    setLoading(true);
    // Applications
    const careers = await safeFetchJson(toUrl('/api/careers/admin'));
    let applicationsNew: number | null = null;
    if (Array.isArray(careers)) {
      if (careers.length && typeof careers[0]?.status !== 'undefined') {
        applicationsNew = careers.filter((c: any) => (c.status || '').toLowerCase() === 'new' || (c.status || '').toLowerCase() === 'pending').length;
      } else {
        applicationsNew = careers.length;
      }
    }

    // Media
    const media = await safeFetchJson(toUrl('/api/media/admin'));
    const mediaCount = Array.isArray(media) ? media.length : null;

    // Doctors
    // Prefer doctors-intro list if available; fallback to page-doctors-hero list
    let doctorsCount: number | null = null;
    const doctorsIntro = await safeFetchJson(toUrl('/api/doctors-intro/admin'));
    if (Array.isArray(doctorsIntro)) {
      doctorsCount = doctorsIntro.length;
    } else {
      const doctorsHero = await safeFetchJson(toUrl('/api/page-doctors-hero/admin/hekimler'));
      doctorsCount = Array.isArray(doctorsHero) ? doctorsHero.length : null;
    }

    setStats({
      applicationsNew,
      media: mediaCount,
      doctors: doctorsCount,
    });
    setLoading(false);
  }, []);

  React.useEffect(() => { refresh(); }, [refresh]);

  const fmt = (n: number | null) => (n === null ? '—' : String(n));

  return (
    <div className="dashboard">
      <div className="dash-header">
        <div>
          <h1>Yönetim Paneli</h1>
          <p className="muted">Hızlı özet ve kısayollar</p>
        </div>
        <div>
          <button className="btn" onClick={refresh} disabled={loading}>{loading ? 'Yenileniyor...' : 'Yenile'}</button>
        </div>
      </div>

      <section className="cards-grid">
        <div className="card stat">
          <div className="stat-value">{fmt(stats.applicationsNew)}</div>
          <div className="stat-label">Yeni Başvurular</div>
        </div>
        <div className="card stat">
          <div className="stat-value">{fmt(stats.media)}</div>
          <div className="stat-label">Medya Dosyaları</div>
        </div>
        <div className="card stat">
          <div className="stat-value">{fmt(stats.doctors)}</div>
          <div className="stat-label">Hekimler</div>
        </div>
        
      </section>

      <section className="quick-actions">
        <h3>Hızlı İşlemler</h3>
        <div className="actions">
          <a className="action" href="/admin/media">Medya Yönetimi</a>
          <a className="action" href="/admin/careers">Başvurular</a>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
